import { baseApiUrl } from 'src/config';
import { getAccessToken } from 'src/routes/AuthContext';

export type DraftDocument = {
  documentType: string;
  todayLocalDate: Date;
  providerName: string;
  providerId: string;
  reformId: string;
  webhookUuid: string;
  submissionData: string | null;
  lastEdited: Date;
};

export const getDraftDocuments = async (
  episodeOfCareId: string,
  discipline: 'PT' | 'OT' | 'SLP',
  realm: string
): Promise<DraftDocument[]> => {
  const token = await getAccessToken();

  return fetch(
    `${baseApiUrl}/document/draft/get-draft-documents/${episodeOfCareId}?discipline=${discipline}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'x-tenant-id': realm,
      },
    }
  )
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      return data.data;
    })
    .catch((error) => {
      throw Error(`Error fetching draft documents: ${error}`);
    });
};
